var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg013SgScheduleADemo = function Svg013SgScheduleADemo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 298.041V133.959C82 78.753 126.644 34 181.716 34H121C65.771 34 21 78.772 21 134v164c0 55.228 44.771 100 100 100h60.716C126.644 398 82 353.247 82 298.041z",
    fill: "#a0eda2",
    "data-original": "#cee1f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M492 134v164c0 55.228-44.772 100-100 100H119.979C64.762 398 20 353.238 20 298.021V134C20 78.772 64.772 34 120 34h272c55.228 0 100 44.772 100 100zM352 478H160",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 164c0-23.748 19.252-43 43-43s43 19.252 43 43-19.252 43-43 43-43-19.252-43-43zm106.081 150c-6.726-25.785-30.361-45-58.487-45h-11.187c-28.126 0-51.761 19.215-58.487 45",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#14d64d",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf3"
  }));
};

export default Svg013SgScheduleADemo;